import { z } from 'zod';
import { inventoryUnitSchema } from '../units.js';
export const locationKindSchema = z.enum(['fridge', 'freezer', 'cupboard', 'other']);
export const locationSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    kind: locationKindSchema,
    position: z.number().int(),
    itemCount: z.number().int(),
});
export const locationInputSchema = z.object({
    name: z.string().min(1).max(60),
    kind: locationKindSchema.default('other'),
    position: z.number().int().min(0).max(100).default(0),
});
export const inventoryItemSchema = z.object({
    id: z.string().uuid(),
    locationId: z.string().uuid(),
    locationName: z.string(),
    foodId: z.string().uuid().nullable(),
    foodName: z.string().nullable(),
    brand: z.string().nullable(),
    recipeId: z.string().uuid().nullable(),
    recipeTitle: z.string().nullable(),
    quantity: z.number(),
    unit: inventoryUnitSchema,
    addedOn: z.string(),
    bestBefore: z.string().nullable(),
    openedOn: z.string().nullable(),
    status: z.enum(['active', 'used', 'discarded']),
    note: z.string().nullable(),
    /** Negative once past its date; null when no date was given. */
    daysToBestBefore: z.number().int().nullable(),
    useSoon: z.boolean(),
});
export const addInventoryItemSchema = z
    .object({
    locationId: z.string().uuid(),
    foodId: z.string().uuid().nullish(),
    recipeId: z.string().uuid().nullish(),
    quantity: z.number().positive(),
    unit: inventoryUnitSchema,
    bestBefore: z.string().date().nullish(),
    openedOn: z.string().date().nullish(),
    note: z.string().max(300).nullish(),
})
    .refine((v) => Boolean(v.foodId) !== Boolean(v.recipeId), {
    message: 'An inventory item is either a food or a leftover recipe, not both',
})
    .refine((v) => v.unit !== 'serving' || Boolean(v.recipeId), {
    message: 'Servings only apply to a leftover recipe',
});
export const adjustInventoryItemSchema = z.object({
    /** The quantity after the adjustment, not the amount removed. */
    quantity: z.number().min(0),
    reason: z.enum(['adjusted', 'eaten', 'discarded', 'cooked']).default('adjusted'),
    note: z.string().max(300).nullish(),
});
export const inventoryQuerySchema = z.object({
    locationId: z.string().uuid().optional(),
    q: z.string().max(120).optional(),
    includeUsed: z
        .union([z.boolean(), z.string()])
        .default(false)
        .transform((v) => (typeof v === 'boolean' ? v : !['false', '0', 'no', ''].includes(v))),
});
export const useSoonSchema = z.object({
    items: z.array(inventoryItemSchema),
    recipes: z.array(z.object({
        id: z.string().uuid(),
        title: z.string(),
        /** How many of the soon-to-expire items this recipe would use. */
        usesCount: z.number().int(),
        usesFoodIds: z.array(z.string().uuid()),
        energyKcalPerServing: z.number().nullable(),
        totalMinutes: z.number().int().nullable(),
    })),
});
export const stapleSchema = z.object({
    id: z.string().uuid(),
    foodId: z.string().uuid(),
    foodName: z.string(),
    parQuantity: z.number(),
    unit: inventoryUnitSchema,
    currentQuantity: z.number(),
    belowPar: z.boolean(),
});
export const stapleInputSchema = z.object({
    foodId: z.string().uuid(),
    parQuantity: z.number().positive(),
    unit: inventoryUnitSchema,
});
//# sourceMappingURL=inventory.js.map